import React, { useState, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import classes from "./BackToTop.module.css";
import { FaArrowUp } from "react-icons/fa";

gsap.registerPlugin(ScrollToPlugin);

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    const lenis = window.__lenis;

    if (lenis) {
      lenis.scrollTo(0, {
        duration: 1,
        lock: true,
      });
      return;
    }

    gsap.killTweensOf(window);
    gsap.to(window, {
      duration: 0.8,
      ease: "power2.out",
      scrollTo: { y: 0, autoKill: false },
    });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className={classes.backToTop}
      title="Scroll to top"
    >
      <FaArrowUp />
    </button>
  );
}
